import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../App';

const RANK = { admin: 3, editor: 2, viewer: 1 };

const NAV = [
  { to: '/', label: 'Dashboard', end: true,
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8"/><rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8"/><rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8"/><rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8"/></svg> },
  { to: '/contacts', label: 'Επαφές',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="1.8"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg> },
  { to: '/emails/compose', label: 'Αποστολή Email', role: 'editor',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M22 2L11 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M22 2L15 22l-4-9-9-4 20-7z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg> },
  { to: '/emails/log', label: 'Ιστορικό Email',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="1.8"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg> },
  { to: '/users', label: 'Χρήστες', role: 'admin',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="1.8"/></svg> },
  { to: '/settings', label: 'Ρυθμίσεις', role: 'admin',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" stroke="currentColor" strokeWidth="1.8"/></svg> },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };
  const initials = (user.full_name || user.username || 'U').split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase();

  const currentPage = NAV.find(n => n.end ? location.pathname === n.to : location.pathname.startsWith(n.to));

  const SidebarContent = () => (
    <>
      {/* Logo */}
      <div style={{ padding: '20px 16px', marginBottom: '4px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{
            width: '32px', height: '32px', borderRadius: '8px',
            background: 'rgba(201,147,10,0.15)', border: '1px solid rgba(201,147,10,0.25)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
          }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <rect x="2" y="3" width="20" height="14" rx="2" stroke="#C9930A" strokeWidth="1.8"/>
              <path d="M6 8h12M6 11h8" stroke="#C9930A" strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
          </div>
          <div>
            <div style={{ color: '#F8FAFC', fontSize: '12px', fontWeight: 700, fontFamily: 'Inter, sans-serif', letterSpacing: '0.02em' }}>CYPRONETWORK</div>
            <div style={{ color: 'rgba(248,250,252,0.3)', fontSize: '10px', letterSpacing: '0.03em' }}>DataBank Pro v3</div>
          </div>
        </div>
      </div>

      {/* Section label */}
      <div style={{ padding: '0 16px 6px', fontSize: '10px', fontWeight: 600, color: 'rgba(248,250,252,0.2)', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
        Πλοήγηση
      </div>

      {/* Nav items */}
      <nav style={{ padding: '0 8px', flex: 1 }}>
        {NAV.filter(n => !n.role || RANK[user.role] >= RANK[n.role]).map(({ to, label, icon, end }) => (
          <NavLink key={to} to={to} end={end} onClick={() => setMobileOpen(false)}
            style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: '9px',
              padding: '8px 10px', borderRadius: '8px', marginBottom: '1px',
              textDecoration: 'none', fontSize: '13px', fontWeight: 500, transition: 'all 0.12s',
              color: isActive ? '#F8FAFC' : 'rgba(248,250,252,0.45)',
              background: isActive ? 'rgba(248,250,252,0.08)' : 'transparent',
              borderLeft: isActive ? '2px solid #C9930A' : '2px solid transparent',
            })}
          >
            {icon}{label}
          </NavLink>
        ))}
      </nav>

      {/* User footer */}
      <div style={{ padding: '12px 8px', borderTop: '1px solid rgba(248,250,252,0.06)' }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: '10px',
          padding: '8px 10px', borderRadius: '8px',
          background: 'rgba(248,250,252,0.04)',
        }}>
          <div style={{
            width: '28px', height: '28px', borderRadius: '50%', flexShrink: 0,
            background: 'linear-gradient(135deg, #C9930A, #F5C842)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '11px', fontWeight: 700, color: '#0A0F1E', fontFamily: 'Inter, sans-serif'
          }}>{initials}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ color: '#F8FAFC', fontSize: '12px', fontWeight: 600 }} className="truncate">
              {user.full_name || user.username}
            </div>
            <div style={{ color: 'rgba(248,250,252,0.3)', fontSize: '10px', textTransform: 'capitalize' }}>{user.role}</div>
          </div>
          <button onClick={handleLogout} title="Αποσύνδεση" style={{
            background: 'none', border: 'none', cursor: 'pointer', padding: '4px',
            color: 'rgba(248,250,252,0.25)', borderRadius: '4px', display: 'flex', transition: 'color 0.12s'
          }}
            onMouseOver={e => e.currentTarget.style.color = 'rgba(220,38,38,0.8)'}
            onMouseOut={e => e.currentTarget.style.color = 'rgba(248,250,252,0.25)'}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </button>
        </div>
      </div>
    </>
  );

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--paper)' }}>
      {/* Desktop Sidebar */}
      <aside style={{
        width: 'var(--sidebar)', flexShrink: 0,
        background: '#0D1526',
        display: 'flex', flexDirection: 'column',
        position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 100,
      }} className="sidebar-desktop">
        <SidebarContent />
      </aside>

      {/* Mobile Header */}
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: '52px', zIndex: 200,
        background: '#0D1526', borderBottom: '1px solid rgba(248,250,252,0.06)',
        display: 'none', alignItems: 'center', padding: '0 16px', gap: '12px'
      }} className="mobile-header">
        <button onClick={() => setMobileOpen(!mobileOpen)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'rgba(248,250,252,0.7)', padding: '4px', display: 'flex' }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M3 12h18M3 6h18M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
        </button>
        <span style={{ color: '#F8FAFC', fontSize: '14px', fontWeight: 600, fontFamily: 'Inter, sans-serif' }}>
          {currentPage?.label || 'DataBank'}
        </span>
      </div>

      {/* Mobile Drawer */}
      {mobileOpen && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 300 }}>
          <div onClick={() => setMobileOpen(false)} style={{ position: 'absolute', inset: 0, background: 'rgba(10,15,30,0.6)', backdropFilter: 'blur(4px)' }} />
          <aside style={{
            position: 'absolute', top: 0, left: 0, bottom: 0, width: '260px',
            background: '#0D1526', display: 'flex', flexDirection: 'column',
            animation: 'slideRight 0.2s ease'
          }}>
            <SidebarContent />
          </aside>
        </div>
      )}

      {/* Main */}
      <main style={{ flex: 1, marginLeft: 'var(--sidebar)', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        {/* Top bar */}
        <div style={{
          height: '52px', borderBottom: '1px solid var(--silver)',
          background: 'var(--white)', display: 'flex', alignItems: 'center',
          padding: '0 28px', gap: '8px', flexShrink: 0, position: 'sticky', top: 0, zIndex: 50
        }}>
          <span style={{ color: 'var(--mist)', fontSize: '13px' }}>CyproNetwork</span>
          <span style={{ color: 'var(--cloud)', fontSize: '13px' }}>/</span>
          <span style={{ color: 'var(--ink)', fontSize: '13px', fontWeight: 500 }}>{currentPage?.label || '—'}</span>
        </div>
        <div style={{ flex: 1, padding: '28px 28px' }}>
          <Outlet />
        </div>
      </main>

      <style>{`
        @media (max-width: 768px) {
          .sidebar-desktop { display: none !important; }
          .mobile-header { display: flex !important; }
          main { margin-left: 0 !important; padding-top: 52px; }
          main > div { padding: 20px 16px !important; }
        }
        @keyframes slideRight { from { transform: translateX(-100%); } to { transform: translateX(0); } }
      `}</style>
    </div>
  );
}
